import React from "react";
import { DeleteIcon, ArrowIcon } from "assets";

import { IMultiSelectItem } from "../MultiSelectItem";
import cx from "classnames";

export interface IMultiSelectListItemProps<TValue> {
  item: IMultiSelectItem<TValue>;
  isUpMovable: boolean;
  isDownMovable: boolean;
  hideMoveControls?: boolean;
  moveElementUp: (id: any) => void;
  moveElementDown: (id: any) => void;
  removeItem: (id: any) => void;
}

export class MultiSelectListItem<TValue> extends React.Component<
  IMultiSelectListItemProps<TValue>
> {
  public render() {
    const {
      item: { name },
    } = this.props;

    return (
      <div className="c-multi-select-list__selected-item" key={name}>
        <div className="c-multi-select-list__selected-item-name">{name}</div>
        {this.renderButtons()}
      </div>
    );
  }

  private readonly renderButtons = () => {
    const { isUpMovable, isDownMovable, hideMoveControls } = this.props;

    const actionStyle =
      "c-multi-select-list__selected-item-action flex items-center justify-center text-color-brand-one hover:text-color-brand-two";
    const arrowDownStyles = cx(actionStyle, {
      "disable pointer-events-none text-color-neutral-two": !isDownMovable,
    });
    const arrowUpStyles = cx(actionStyle, {
      "disable pointer-events-none text-color-neutral-two": !isUpMovable,
    });

    return (
      <React.Fragment>
        {!hideMoveControls && (
          <div
            className={arrowDownStyles}
            onKeyPress={(e) => e.key === "Enter" && this.moveDownHandler()}
            onClick={this.moveDownHandler}
            tabIndex={isDownMovable ? 0 : -1}
            role="button"
            aria-label="Move down"
          >
            <ArrowIcon className="rotate-180" width={40} height={40} />
          </div>
        )}
        {!hideMoveControls && (
          <div
            className={arrowUpStyles}
            onKeyPress={(e) => e.key === "Enter" && this.moveUpHandler()}
            onClick={this.moveUpHandler}
            tabIndex={isUpMovable ? 0 : -1}
            role="button"
            aria-label="Move up"
          >
            <ArrowIcon width={40} height={40} />
          </div>
        )}
        <div
          className="c-multi-select-list__selected-item-action text-color-brand-one hover:text-color-brand-two flex items-center justify-center"
          onKeyPress={(e) => e.key === "Enter" && this.removeHandler()}
          onClick={this.removeHandler}
          tabIndex={0}
          role="button"
          aria-label="Delete"
        >
          <DeleteIcon width={40} height={40} />
        </div>
      </React.Fragment>
    );
  };

  private readonly moveUpHandler = () => {
    const {
      moveElementUp,
      isUpMovable,
      item: { value },
    } = this.props;

    if (isUpMovable) {
      moveElementUp(value);
    }
  };

  private readonly moveDownHandler = () => {
    const {
      moveElementDown,
      isDownMovable,
      item: { value },
    } = this.props;

    if (isDownMovable) {
      moveElementDown(value);
    }
  };

  private readonly removeHandler = () => {
    const {
      removeItem,
      item: { value },
    } = this.props;
    removeItem(value);
  };
}
